import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { MakeSensorsReadyToUsePayload, MakeSensorsReadyToUseResponse } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<
    UseMutationOptions<MakeSensorsReadyToUseResponse[], Error, MakeSensorsReadyToUsePayload>,
    'mutationKey' | 'mutationFn'
  >
}

export const useMakeSensorsReadyToUseBulk = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<MakeSensorsReadyToUseResponse[], Error, MakeSensorsReadyToUsePayload>(
    [Entities.Sensors, 'make-ready-to-use'],
    async (payload) => {
      const { data } = await api.v1AdminSensorsMakeReadyToUsePost(payload)
      return data as MakeSensorsReadyToUseResponse[]
    },
    options,
  )
}
